import { Collection } from 'backbone';

/**
 * @desc CelebrityTeams
 */
export default class CelebrityTeams extends Collection {

	set_show_my_url() {
		this.url = 'leagues_classic/celebrity_teams';
		return this;
	}

	/**
	 * Method get teams joined to current league
	 * @param {object} data
	 * @returns {Promise.<Object>|*}
	 */
	show_my( data = {} ) {
		return this.set_show_my_url().fetch( { data } );
	}

	set_celebrity_teams_url() {
		this.url = 'leagues_classic/add_celebrity_teams';
		return this;
	}

	add_celebrity_teams( data = {} ) {
		return this.set_celebrity_teams_url()
			.fetch( { data } ).then( response => {
				if ( response.errors.length ) {
					this.trigger( 'add:celebrity:teams:error', response.errors );
				}
				else {
					this.trigger( 'add:celebrity:teams:success' );
				}
			} );
	}

}